import { useContext, useEffect, useState, useTransition } from "react";

import { isValidPositiveNumber, NO_VALUE_DISPLAY } from "@ryde/shared";

import { DropdownSourceContext } from "../../contexts";

export interface IAreaTitleDto {
  title: string;
  areaGroupId?: number;
  areaGroupName?: string;
  defaultSupplierId?: number;
}

const emptyAreaTitle = (): IAreaTitleDto => ({
  title: NO_VALUE_DISPLAY,
});

export const useAreaTitle = (areaId: number | undefined): IAreaTitleDto => {
  const { getDropdownItems } = useContext(DropdownSourceContext);
  const [areaTitleDto, setAreaTitleDto] = useState<IAreaTitleDto>(() =>
    emptyAreaTitle(),
  );
  const [, startTransition] = useTransition();

  useEffect(() => {
    const fetchTitle = async (): Promise<void> => {
      if (!areaId) {
        setAreaTitleDto(emptyAreaTitle());
        return;
      }

      const items = await getDropdownItems("area");
      const item = items.find(x => Number(x.value) === areaId);

      if (!item) {
        setAreaTitleDto(emptyAreaTitle());
        return;
      }

      setAreaTitleDto({
        title: item.label || NO_VALUE_DISPLAY,
        areaGroupId: isValidPositiveNumber(item.areaGroupId)
          ? item.areaGroupId
          : undefined,
        areaGroupName: item.areaGroupName,
        defaultSupplierId: isValidPositiveNumber(item.defaultSupplierId)
          ? item.defaultSupplierId
          : undefined,
      });
    };

    startTransition(() => {
      void fetchTitle();
    });
  }, [areaId, getDropdownItems]);

  return areaTitleDto;
};
